import type { FC } from 'react';
import WarningIcon from '@public/assets/common/icons/warningIcon.svg';
import type { AcceptanceBetsStoppedProps } from './AcceptanceBetsStopped.types';
import styles from './AcceptanceBetsStopped.module.scss';
export const AcceptanceBetsStopped: FC<AcceptanceBetsStoppedProps> = ({
  className,
  classes,
  children
}) => {
  return <div className={cn(styles.root, className)} data-sentry-component="AcceptanceBetsStopped" data-sentry-source-file="AcceptanceBetsStopped.tsx">
      <div className={cn(styles.content, classes?.content)}>
        <WarningIcon className={styles.icon} data-sentry-element="WarningIcon" data-sentry-source-file="AcceptanceBetsStopped.tsx" />
        <span className={styles.text}>{children}</span>
      </div>
    </div>;
};